// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-list-add-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.modal-actions {
  position: absolute;
  top: 20px;
  right: 20px;
}
.modal-actions__close {
  cursor: pointer;
}

.employee-add-modal {
  position: relative;
  padding: 42px 42px 42px 32px;
  width: 600px;
  height: 90%;
  background: #ffffff;
  border-radius: 16px;
  overflow-y: auto;
}
.employee-add-modal__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  color: #333333;
}
.employee-add-modal__employee-info__head {
  margin-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.employee-add-modal__span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #999999;
}
.employee-add-modal__row {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.employee-add-modal__col1 {
  display: flex;
  align-content: center;
  align-items: center;
  width: 25%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.employee-add-modal__col1__text {
  padding-left: 5px;
}
.employee-add-modal__col2 {
  width: 75%;
}
.employee-add-modal__tax-type {
  display: flex;
}
.employee-add-modal__tax-type__select-left {
  width: 33%;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  height: 52px;
  border-radius: 8px 0px 0px 8px;
  text-align: center;
  padding-top: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #505054;
  cursor: pointer;
}
.employee-add-modal__tax-type__select-middle {
  width: 33%;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  height: 52px;
  text-align: center;
  padding-top: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #505054;
  cursor: pointer;
}
.employee-add-modal__tax-type__select-right {
  width: 33%;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  height: 52px;
  border-radius: 0px 8px 8px 0px;
  text-align: center;
  padding-top: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #505054;
  cursor: pointer;
}
.employee-add-modal__tax-type__selected {
  background: #4a515e;
  color: #ffffff;
}
.employee-add-modal__tax-type__select-left:hover, .employee-add-modal__tax-type__select-middle:hover, .employee-add-modal__tax-type__select-right:hover {
  background: #4a515e;
  color: #ffffff;
}
.employee-add-modal__tax-type__dependent-select {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.employee-add-modal__buttons {
  margin-top: 20px;
  display: flex;
}
.employee-add-modal__buttons__cancel {
  width: 100%;
  padding-right: 5px;
}
.employee-add-modal__buttons__submit {
  width: 100%;
  padding-left: 5px;
}

select__menu-list::-webkit-scrollbar {
  width: 4px;
  height: 0px;
}`, "",{"version":3,"sources":["webpack://./src/screens/salary_specification/employee-list-add-modal/employee-list-add-modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AACJ;AAAI;EACI,eAAA;AAER;;AAEA;EACI,kBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACR;AAGQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAKI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHR;AAMI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AAJR;AAOI;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALR;AAOQ;EACI,iBAAA;AALZ;AASI;EACI,UAAA;AAPR;AAUI;EACI,aAAA;AARR;AAUQ;EACI,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AATZ;AAYQ;EACI,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAXZ;AAcQ;EACI,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAbZ;AAgBQ;EACI,mBAAA;EACA,cAAA;AAdZ;AAkBQ;EAGI,mBAAA;EACA,cAAA;AAlBZ;AAqBQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AApBZ;AAwBI;EACI,gBAAA;EACA,aAAA;AAtBR;AAwBQ;EACI,WAAA;EACA,kBAAA;AAtBZ;AAyBQ;EACI,WAAA;EACA,iBAAA;AAvBZ;;AA4BA;EACI,UAAA;EACA,WAAA;AAzBJ","sourcesContent":[".employee-list-add-modal {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.modal-actions {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    &__close {\n        cursor: pointer;\n    }\n}\n\n.employee-add-modal {\n    position: relative;\n    padding: 42px 42px 42px 32px;\n    width: 600px;\n    height: 90%;\n    background: #ffffff;\n    border-radius: 16px;\n    overflow-y: auto;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 26px;\n        line-height: 36px;\n        color: #333333;\n    }\n\n    &__employee-info {\n        &__head {\n            margin-top: 30px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 18px;\n            line-height: 24px;\n            color: #333333;\n        }\n    }\n\n    &__span {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        color: #999999;\n    }\n\n    &__row {\n        margin-top: 20px;\n        display: flex;\n        align-items: center;\n    }\n\n    &__col1 {\n        display: flex;\n        align-content: center;\n        align-items: center;\n        width: 25%;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n\n        &__text {\n            padding-left: 5px;\n        }\n    }\n\n    &__col2 {\n        width: 75%;\n    }\n\n    &__tax-type {\n        display: flex;\n\n        &__select-left {\n            width: 33%;\n            background: #ffffff;\n            border: 1px solid #e1e1e1;\n            height: 52px;\n            border-radius: 8px 0px 0px 8px;\n            text-align: center;\n            padding-top: 15px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #505054;\n            cursor: pointer;\n        }\n\n        &__select-middle {\n            width: 33%;\n            background: #ffffff;\n            border: 1px solid #e1e1e1;\n            height: 52px;\n            text-align: center;\n            padding-top: 15px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #505054;\n            cursor: pointer;\n        }\n\n        &__select-right {\n            width: 33%;\n            background: #ffffff;\n            border: 1px solid #e1e1e1;\n            height: 52px;\n            border-radius: 0px 8px 8px 0px;\n            text-align: center;\n            padding-top: 15px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #505054;\n            cursor: pointer;\n        }\n\n        &__selected {\n            background: #4a515e;\n            color: #ffffff;\n        }\n\n\n        &__select-left:hover,\n        &__select-middle:hover,\n        &__select-right:hover {\n            background: #4a515e;\n            color: #ffffff;\n        }\n\n        &__dependent-select {\n            width: 100%;\n            height: 56px;\n            background: #ffffff;\n            border: 1px solid #e9e9e9;\n            border-radius: 8px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n        }\n    }\n\n    &__buttons {\n        margin-top: 20px;\n        display: flex;\n\n        &__cancel {\n            width: 100%;\n            padding-right: 5px;\n        }\n\n        &__submit {\n            width: 100%;\n            padding-left: 5px;\n        }\n    }\n}\n\nselect__menu-list::-webkit-scrollbar {\n    width: 4px;\n    height: 0px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
